export default __webpack_public_path__ + "static/media/about.365b17eb.jpg";